var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import useLogo from '../../../helpers/hooks/useLogo';
const Logo = () => {
    _react_refresh_temp_2();
    const logo = useLogo('waiting-room');
    return (_jsx("div", { className: "waiting-room-logo", children: _jsx("img", { className: "waiting-room-logo-img", src: `${logo}`, alt: "logo" }) }));
};
_react_refresh_temp_1 = Logo;
$RefreshReg$(_react_refresh_temp_1, "Logo");
_react_refresh_temp_2(Logo, "YgIq2xNtRL4gwdBSBNon6XMW2hw=", false, () => [useLogo]);
export default Logo;
